import { VehicleType } from './vehicle-type';
import { VehicleInterface } from '../interfaces/api';

export class Vehicle implements VehicleInterface {

    height: number;

    id: number;

    length: number;

    trailer_reg: string;

    type: VehicleType;

    vehicle_reg: string;

    weight: number;

    width: number;

    get weight_formatted(): string {
        if (this.weight === undefined) return 'Unknown';
        let append = ' Tonne';
        if (this.weight !== 1) append += 's';
        return this.weight + append;
    }

    public getLabel(): string {
        let reg = this.vehicle_reg;
        if (!reg) reg = this.trailer_reg;
        if (!reg) reg = 'Unknown Reg';

        return reg;
    }

    static createFromObject(object: any): Vehicle {

        let vehicle = new Vehicle();

        if (object.id !== undefined)            vehicle.id = object.id;
        if (object.height !== undefined)        vehicle.height = object.height;
        if (object.length !== undefined)        vehicle.length = object.length;
        if (object.trailer_reg !== undefined)   vehicle.trailer_reg = object.trailer_reg;
        if (object.type !== undefined)          vehicle.type = VehicleType.createFromObject(object.type);
        if (object.vehicle_reg !== undefined)   vehicle.vehicle_reg = object.vehicle_reg;
        if (object.weight !== undefined)        vehicle.weight = object.weight;
        if (object.width !== undefined)         vehicle.width = object.width;

        return vehicle;
    }

    static createFromObjects(objects: any[]): Vehicle[] {
        let vehicles: Vehicle[] = [];
        for (let object of objects) {
            vehicles.push(Vehicle.createFromObject(object));
        }
        return vehicles;
    }
}



// WEBPACK FOOTER //
// ./src/entities/vehicle.ts